import styled from "styled-components";

export const SlideoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const SlideoutHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const SlideoutSubHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  > *:nth-child(2) {
    color: ${(props) => props.theme.colors.davysGrey || '#5c5c5c'};
  }
`;

export const SlideoutToolsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-right: 8px;
`;

export const SlideoutActions = styled.div`
  display: flex;
  justify-content: right;
  gap: 8px;
  padding: 16px 24px;
  margin-top: auto;
`;

export const ToolsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 24px;
`;

export const ToolsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
`;

export const ToolCardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const ToolCardContent = styled.div`
  flex: 1;
`;

export const ToolCardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
`;

export const ToolCardDescription = styled.div`
  color: ${(props) => props.theme.colors.davysGrey || '#666'};
`;

